module.exports = __webpack_public_path__ + "static/media/solo18.61b8245c.JPG";